<div class="main">
    <div class="dx-field-title" translate>fileTransfers.pageTitle</div>
    <div class="dx-fieldset" style="height:calc(100vh - 150px)">
        <dx-data-grid #fileTransfers
                      id="dgFileTransfers"
                      [dataSource]="dataSource"
                      keyExpr="id"
                      [columnAutoWidth]="true"
                      [allowColumnResizing]="true"
                      height="100%"
                      hoverStateEnabled="true"
                      [focusedRowEnabled]="true"
                      [errorRowEnabled]="false"
                      (onRowPrepared)="onRowPrepared($event)"
                      (onRowDblClick)="onRowDblClick($event)"
                      (onContextMenuPreparing)="onContextMenuPreparing($event)">
            <dxo-editing mode="row"></dxo-editing>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-scrolling showScrollbar="always"></dxo-scrolling>
            <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-summary>
                <dxi-total-item column="name" [displayFormat]="'fileTransfers.lblTransfersCount' | translate" summaryType="count"></dxi-total-item>
            </dxo-summary>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div *dxTemplate>
                        <span style="vertical-align:middle;" translate>fileTransfers.lblShowDisabledTransfers</span>
                        <dx-switch style="margin-left:5px;" [value]="showDisabledTransfers" (valueChange)="filterChanged($event)"></dx-switch>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="openNewCreationForm()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="add" [text]="'_commons.addWithOldForm' | translate" (onClick)="displayNewPopup()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadData()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>

            <dxi-column dataField="name" [caption]="'fileTransfers.lblTransferName' | translate" sortOrder="asc"></dxi-column>
            <dxi-column dataField="localAgent.name" [caption]="'fileTransfers.lblAgent' | translate"></dxi-column>
            <dxi-column dataField="executionMode" [caption]="'fileTransfers.lblExecutionMode' | translate" [calculateCellValue]="displayExecutionMode"></dxi-column>
            <dxi-column dataField="fileNamePattern" [caption]="'fileTransfers.lblFileName' | translate"></dxi-column>
            <dxi-column dataField="source.displayName" [caption]="'fileTransfers.lblSourcePlatform' | translate"></dxi-column>
            <dxi-column dataField="sourceFolder" [caption]="'fileTransfers.lblSourceFolder' | translate"></dxi-column>
            <dxi-column dataField="target.displayName" [caption]="'fileTransfers.lblTargetPlatform' | translate"></dxi-column>
            <dxi-column dataField="targetFolder" [caption]="'fileTransfers.lblTargetFolder' | translate"></dxi-column>
            <dxi-column dataField="archives.displayName" [caption]="'fileTransfers.lblArchivesPlatform' | translate"></dxi-column>
            <dxi-column dataField="archivesFolder" [caption]="'fileTransfers.lblArchivesFolder' | translate"></dxi-column>
            <dxi-column dataField="executeAfter.name" [caption]="'fileTransfers.lblExecuteAfter' | translate"></dxi-column>
        </dx-data-grid>
    </div>
</div>

<!-- Display popup -->
<dx-popup [title]="'fileTransfers.popupTitle' | translate" [(visible)]="isDisplayPopupVisible" width="100vw">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view id="scrollview">
            <div class="dx-fieldset">
                <div class="dx-fieldset-header" translate>fileTransfers.lblGeneral</div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblIsDisabled</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.isDisabled"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.environmentId</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.environmentId" style="float:left;width:70%"></dx-text-box>
                        <dx-button ngxClipboard [cbContent]="displayedFileTransfer.environmentId" (onClick)="notifyCopy()" icon="key" style="float:left;margin-left:8px"></dx-button>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.id</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.id" style="float:left;width:70%"></dx-text-box>
                        <dx-button ngxClipboard [cbContent]="displayedFileTransfer.id" (onClick)="notifyCopy()" icon="key" style="float:left;margin-left:8px"></dx-button>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblTransferName</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.name"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblAgent</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.localAgent.name"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblExecutionMode</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [value]="displayExecutionMode(displayedFileTransfer)"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="displayedFileTransfer.executeAfter">
                    <div class="dx-field-label" translate>fileTransfers.lblExecuteAfter</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.executeAfter.name"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblFileName</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.fileNamePattern"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblRenamingParamSeparator</div>
                    <div class="dx-field-value" style="width:120px;float:left">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.renamingParametersSeparator"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblReplaceSpecialCharFileName</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.replaceSpecialCharactersInFileName"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblSendFileInNotificationEmail</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.sendFileInNotificationEmail"></dx-switch>
                    </div>
                </div>
            </div>
            <div class="dx-fieldset">
                <div class="dx-fieldset-header" translate>fileTransfers.lblACK</div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblAckManagement</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.ackManagement"></dx-switch>
                    </div>
                </div>
                <div class="dx-field" *ngIf="displayedFileTransfer.ackManagement">
                    <div class="dx-field-label" translate>fileTransfers.lblAckOkExtension</div>
                    <div class="dx-field-value" style="width:120px;float:left">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.ackokExtension"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="displayedFileTransfer.ackManagement">
                    <div class="dx-field-label" translate>fileTransfers.lblAckKoExtension</div>
                    <div class="dx-field-value" style="width:120px;float:left">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.ackkoExtension"></dx-text-box>
                    </div>
                </div>
            </div>
            <div class="dx-fieldset">
                <div class="dx-fieldset-header" translate>fileTransfers.lblSource</div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblSourcePlatform</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.source.displayName"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblSourceFolder</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.sourceFolder"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblDecryptFile</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [value]="displayedFileTransfer.decryptionKey?.name"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblDelTsfdFileFromSource</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.deleteTransferredFileFromSource"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblIgnoreEmptyFiles</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.ignoreEmptyFiles"></dx-switch>
                    </div>
                </div>
                <div class="dx-field" *ngIf="displayedFileTransfer.ignoreEmptyFiles">
                    <div class="dx-field-label" translate>fileTransfers.lblRemoveEmptyFiles</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.removeEmptyFiles"></dx-switch>
                    </div>
                </div>
                <div class="dx-field" *ngIf="displayedFileTransfer.ignoreEmptyFiles">
                    <div class="dx-field-label" translate>fileTransfers.lblCreateLogForIgnoredEmptyFiles</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.createLogForIgnoredEmptyFiles"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.tags</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="displayedFileTransfer.sourceTags"
                                    [readOnly]="true"
                                    placeholder=""
                                    [(value)]="displayedFileTransfer.sourceTags">
                        </dx-tag-box>
                    </div>
                </div>
            </div>
            <div class="dx-fieldset">
                <div class="dx-fieldset-header" translate>fileTransfers.lblTarget</div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblTargetPlatform</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.target.displayName"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblTargetFolder</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.targetFolder"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblEncryptFile</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [value]="displayedFileTransfer.encryptionKey?.name"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblExtractZipArchiveInTargetFolder</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.extractZipArchiveInTargetFolder"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblOverwriteFileInTargetFolder</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.overwriteFileInTargetFolder"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblReplaceUnixLineFeedCharacters</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.replaceUnixLineFeedCharacter"></dx-switch>
                    </div>
                </div>
                <div class="dx-field" *ngIf="displayedFileTransfer.ackManagement">
                    <div class="dx-field-label" translate>fileTransfers.lblAckFolder</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.ackFolder"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.tags</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="displayedFileTransfer.targetTags"
                                    [readOnly]="true"
                                    placeholder=""
                                    [(value)]="displayedFileTransfer.targetTags">
                        </dx-tag-box>
                    </div>
                </div>
            </div>
            <div class="dx-fieldset">
                <div class="dx-fieldset-header" translate>fileTransfers.lblArchives</div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblArchivesPlatform</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.archives.displayName"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblArchivesFolder</div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="true" [(value)]="displayedFileTransfer.archivesFolder"></dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfers.lblRenameOnlyArchivedFiles</div>
                    <div class="dx-field-value">
                        <dx-switch [readOnly]="true" [(value)]="displayedFileTransfer.renameOnlyArchivedFiles"></dx-switch>
                    </div>
                </div>
            </div>
            <div class="flex bottom-buttons">
                <dx-button class="close" [text]="'_commons.close' | translate" (onClick)="this.isDisplayPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- New & Edit popup -->
<dx-popup [title]="'fileTransfers.popupTitle' | translate" [(visible)]="isEditPopupVisible" width="100vw">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isEditPopupVisible">
            <dx-validation-group #fileTransferValidation>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>fileTransfers.lblGeneral</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            fileTransfers.lblTransferName<span class="dx-field-item-required-mark">*</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="selectedFileTransfer.name">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgTransferNameRequired' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule type="stringLength" [max]="100" message="'_validators.maxLength100' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            fileTransfers.lblAgent<span class="dx-field-item-required-mark">*</span>
                        </div>
                        <div class="dx-field-value">
                            <app-local-agent-picker [localAgents]="currentEnvironmentLocalAgents" [isRequired]="true"
                                                    [(selectedItem)]="selectedFileTransfer.localAgent"></app-local-agent-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblExecutionMode</div>
                        <div class="dx-field-value">
                            <app-execution-mode-picker [(selectedItem)]="selectedFileTransfer.executionMode"></app-execution-mode-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblExecuteAfter</div>
                        <div class="dx-field-value">
                            <app-file-transfer-info-picker [fileTransfers]="currentEnvironmentFileTransfersInfo" [isRequired]="false"
                                                           [(selectedItem)]="selectedFileTransfer.executeAfter"></app-file-transfer-info-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblFileName</div>
                        <div class="dx-field-value" id="dvFileNamePattern">
                            <dx-text-box [(value)]="selectedFileTransfer.fileNamePattern">
                                <dx-validator>
                                    <dxi-validation-rule type="stringLength" [max]="100" [message]="'_validators.maxLength100' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <dx-tooltip target="#dvFileNamePattern"
                                    showEvent="dxhoverstart"
                                    hideEvent="dxhoverend">
                            <div *dxTemplate="let data of 'content'">
                                <div class="tooltipText">
                                    <p class="tooltipTitleText" translate>fileTransfers.lblAuthorizedVariables</p><br />
                                    <span class="tooltipTitleText">%DateTime% : </span><span class="tooltipText">MyFileName-%DateTime%.txt (MyFileName-190618173256.txt)</span><br />
                                    <span class="tooltipTitleText">%DateTimeUtc% : </span><span class="tooltipText">MyFileName-%DateTimeUtc%.txt (MyFileName-190618153256.txt)</span><br />
                                    <span class="tooltipTitleText">%DateTime:<em>format</em>% : </span><span class="tooltipText">MyFileName-%DateTime:yyyyMMdd_HHmmss%.txt (MyFileName-20190618_173256.txt)</span><br />
                                    <span class="tooltipTitleText">%DateTimeUtc:<em>format</em>% : </span><span class="tooltipText">MyFileName-%DateTimeUtc:yyyyMMdd_HHmmss%.txt (MyFileName-20190618_153256.txt)</span><br />
                                    <br />
                                    <p class="tooltipTitleText" translate>fileTransfers.lblDefaultDateTimeFormatApplied</p>
                                    <p class="tooltipTitleText" translate>fileTransfers.lblWildcardsAuthorizedWithVariables</p>
                                </div>
                            </div>
                        </dx-tooltip>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblRenamingParamSeparator</div>
                        <div class="dx-field-value" style="width:120px;float:left">
                            <dx-text-box [(value)]="selectedFileTransfer.renamingParametersSeparator">
                                <dx-validator>
                                    <dxi-validation-rule type="stringLength" [max]="10" [message]="'_validators.maxLength10' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblReplaceSpecialCharFileName</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.replaceSpecialCharactersInFileName"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblSendFileInNotificationEmail</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.sendFileInNotificationEmail"></dx-switch>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>fileTransfers.lblACK</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblAckManagement</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.ackManagement"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="selectedFileTransfer.ackManagement">
                        <div class="dx-field-label" translate>fileTransfers.lblAckOkExtension</div>
                        <div class="dx-field-value" style="width:120px;float:left">
                            <dx-text-box [(value)]="selectedFileTransfer.ackokExtension">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgAckOkRequired' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule type="stringLength" [max]="20" [message]="'_validators.maxLength20' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="selectedFileTransfer.ackManagement">
                        <div class="dx-field-label" translate>fileTransfers.lblAckKoExtension</div>
                        <div class="dx-field-value" style="width:120px;float:left">
                            <dx-text-box [(value)]="selectedFileTransfer.ackkoExtension">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgAckKoRequired' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule type="stringLength" [max]="20" [message]="'_validators.maxLength20' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>fileTransfers.lblSource</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblSourcePlatform</div>
                        <div class="dx-field-value">
                            <app-remote-platform-picker [platforms]="currentEnvironmentRemotePlatforms" [(selectedItem)]="selectedFileTransfer.source"></app-remote-platform-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            fileTransfers.lblSourceFolder<span class="dx-field-item-required-mark">*</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="selectedFileTransfer.sourceFolder">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgSourceFolderRequired' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule *ngIf="selectedFileTransfer.source === null" type="pattern"
                                                         [pattern]="regexSource" [message]="'_validators.formatUNC' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblDecryptFile</div>
                        <div class="dx-field-value">
                            <app-pgp-key-picker [keys]="currentEnvironmentDecryptionKeys" [(selectedItem)]="selectedFileTransfer.decryptionKey"></app-pgp-key-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblDelTsfdFileFromSource</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.deleteTransferredFileFromSource"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblIgnoreEmptyFiles</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.ignoreEmptyFiles" (onValueChanged)="onIgnoreEmptyFilesChanged($event)"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="selectedFileTransfer.ignoreEmptyFiles">
                        <div class="dx-field-label" translate>fileTransfers.lblRemoveEmptyFiles</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.removeEmptyFiles"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="selectedFileTransfer.ignoreEmptyFiles">
                        <div class="dx-field-label" translate>fileTransfers.lblCreateLogForIgnoredEmptyFiles</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.createLogForIgnoredEmptyFiles"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>_commons.tags</div>
                        <div class="dx-field-value">
                            <dx-tag-box [dataSource]="tags"
                                        [acceptCustomValue]="true"
                                        [searchEnabled]="true"
                                        [showClearButton]="true"
                                        [showSelectionControls]="true"
                                        [noDataText]="'tags.noExistingTag' | translate"
                                        placeholder=""
                                        [(value)]="selectedFileTransfer.sourceTags">
                            </dx-tag-box>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>fileTransfers.lblTarget</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblTargetPlatform</div>
                        <div class="dx-field-value">
                            <app-remote-platform-picker [platforms]="currentEnvironmentRemotePlatforms" [(selectedItem)]="selectedFileTransfer.target"></app-remote-platform-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            fileTransfers.lblTargetFolder<span class="dx-field-item-required-mark">*</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="selectedFileTransfer.targetFolder">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgTargetFolderRequired' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule *ngIf="selectedFileTransfer.target === null" type="pattern"
                                                         [pattern]="regexTarget" [message]="'_validators.formatUNC' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblEncryptFile</div>
                        <div class="dx-field-value">
                            <app-pgp-key-picker [keys]="currentEnvironmentEncryptionKeys" [(selectedItem)]="selectedFileTransfer.encryptionKey"></app-pgp-key-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblExtractZipArchiveInTargetFolder</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.extractZipArchiveInTargetFolder" (onValueChanged)="onExtractZipArchiveInTargetFolder($event)"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblOverwriteFileInTargetFolder</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.overwriteFileInTargetFolder" [readOnly]="selectedFileTransfer.extractZipArchiveInTargetFolder"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblReplaceUnixLineFeedCharacters</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.replaceUnixLineFeedCharacter" [readOnly]="selectedFileTransfer.extractZipArchiveInTargetFolder"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="selectedFileTransfer.ackManagement">
                        <div class="dx-field-label" translate>fileTransfers.lblAckFolder</div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="selectedFileTransfer.ackFolder">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgAckFolderRequired' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule *ngIf="selectedFileTransfer.target === null" type="pattern"
                                                         [pattern]="regexAck" [message]="'_validators.formatUNC' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>_commons.tags</div>
                        <div class="dx-field-value">
                            <dx-tag-box [dataSource]="tags"
                                        [acceptCustomValue]="true"
                                        [searchEnabled]="true"
                                        [showClearButton]="true"
                                        [showSelectionControls]="true"
                                        [noDataText]="'tags.noExistingTag' | translate"
                                        placeholder=""
                                        [(value)]="selectedFileTransfer.targetTags">
                            </dx-tag-box>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>fileTransfers.lblArchives</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblArchivesPlatform</div>
                        <div class="dx-field-value">
                            <app-remote-platform-picker [platforms]="currentEnvironmentRemotePlatforms" [(selectedItem)]="selectedFileTransfer.archives"></app-remote-platform-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblArchivesFolder</div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="selectedFileTransfer.archivesFolder">
                                <dx-validator>
                                    <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate"></dxi-validation-rule>
                                    <dxi-validation-rule *ngIf="selectedFileTransfer.archives === null" type="pattern"
                                                         [pattern]="regexArchives" [message]="'_validators.formatUNC' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>fileTransfers.lblRenameOnlyArchivedFiles</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="selectedFileTransfer.renameOnlyArchivedFiles"></dx-switch>
                        </div>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="add" [text]="'_commons.add' | translate" (onClick)="createFileTransfer()"
                               [visible]="isNew"></dx-button>
                    <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updateFileTransfer()"
                               [visible]="!isNew"></dx-button>
                    <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isEditPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- File transfer execution popup -->
<app-file-transfer-execution #fileTransferExecution/>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
